module.exports = __webpack_public_path__ + "static/media/battery_level_full_icon.f740a2fc.svg";